import { gql } from '@apollo/client';

export default gql`
  query userDashboard {
    space {
      overPlacesLimit
      overInspectionSubjectsLimit
      overInspectionsLimit
      adminRole
      pendingInspectionsTotal
      incomingInspectionsTotal
      overdueInspectionsTotal
      inspectionsTotal
      placesTotal
      inspectionSubjectsTotal
      nextWeekInspectionsTotal
      nextMonthInspectionsTotal
      complianceRatio
      activePlan {
        name
        price
        billingInterval
        placesLimit
        inspectionSubjectsLimit
        inspectionsLimit
      }
    }
    user {
      id
      email
      name
      surname
    }
  }
`;
